var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import { color } from "./themes";
export var bigTextStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: 500;\n  font-size: 27px;\n\n  color: ", ";\n  white-space: pre-wrap;\n"], ["\n  font-weight: 500;\n  font-size: 27px;\n\n  color: ", ";\n  white-space: pre-wrap;\n"])), color("textMain"));
export var BigText = styled.p.withConfig({ displayName: "BigText", componentId: "sc-pxo45l" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), bigTextStyle);
var templateObject_1, templateObject_2;
